/* TrueSanity header (sections/ts-header). No jQuery. Loaded with defer.
   1 pin on scroll: slim row, hides while scrolling down, back on scroll up
   2 mega panels: hover (CSS), plus keyboard focus, tap on touch screens, Esc
   3 phone drawer: menus copied in from <template> on first open; Esc, backdrop and focus kept inside
   4 search panel with live suggestions (Shopify /search/suggest.json)
   5 bag count: keeps the empty state in step when the cart scripts change the number */
(function () {
  'use strict';
  var d = document, w = window;
  var hd = d.querySelector('[data-tsx]');
  if (!hd) return;
  var hold = d.querySelector('[data-tsx-hold]');
  var over = hd.hasAttribute('data-over');
  var hf = hd.getAttribute('data-hf') || ''; // hero-first collections: 'hidden' or 'over'
  var touch = w.matchMedia('(hover: none)');
  var ann = d.querySelector('[data-tsx-ann].tsx-ann--scroll'); // strip that rides above the pinned header
  function annOn(on) {
    if (!ann) return;
    if (on) d.documentElement.style.setProperty('--tsx-ann-h', ann.offsetHeight + 'px');
    ann.classList.toggle('is-on', on); hd.classList.toggle('has-ann', on);
    if (!on) ann.classList.remove('is-away');
  }

  /* 1. pin */
  var lastY = w.scrollY, pinned = false, ticking = false;
  function limit() { return (hold ? hold.offsetTop : 0) + (hf === 'hidden' ? 10 : over ? 120 : hd.offsetHeight); }
  function setPin(on) {
    if (on === pinned) return;
    pinned = on;
    if (on) {
      if (hold && !over && hf !== 'hidden') hold.style.height = hd.offsetHeight + 'px';
      hd.classList.remove('tsx--over', 'tsx--hf');
      hd.classList.add('is-pinned');
      annOn(true);
    } else {
      hd.classList.remove('is-pinned', 'is-away');
      annOn(false);
      if (over) hd.classList.add('tsx--over');
      if (hf === 'hidden') hd.classList.add('tsx--hf');
      if (hold) hold.style.height = '';
    }
    closeAll();
  }
  function onScroll() {
    ticking = false;
    var y = w.scrollY;
    setPin(y > limit());
    if (pinned) {
      var busy = hd.querySelector('.tsx__item.is-open') || (search && !search.hidden);
      if (y > lastY + 4 && y > limit() + 200 && !busy) hd.classList.add('is-away');
      else if (y < lastY - 4) hd.classList.remove('is-away');
      if (ann) ann.classList.toggle('is-away', hd.classList.contains('is-away'));
    }
    lastY = y;
  }
  w.addEventListener('scroll', function () { if (!ticking) { ticking = true; w.requestAnimationFrame(onScroll); } }, { passive: true });

  /* 2. mega panels */
  var items = hd.querySelectorAll('.tsx__item--mega');
  function open(li, on) {
    li.classList.toggle('is-open', on);
    var a = li.querySelector('.tsx__top');
    if (a) a.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (over) hd.classList.toggle('is-lit', !!hd.querySelector('.tsx__item.is-open') || (search && !search.hidden));
  }
  function closeAll(except) { items.forEach(function (li) { if (li !== except) open(li, false); }); }
  items.forEach(function (li) {
    var a = li.querySelector('.tsx__top');
    li.addEventListener('focusin', function () { closeAll(li); open(li, true); });
    li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) open(li, false); });
    li.addEventListener('mouseleave', function () { hd.removeAttribute('data-noh'); if (!li.contains(d.activeElement)) open(li, false); });
    // touch screens wide enough for the menu row: first tap opens, second tap follows the link
    a.addEventListener('click', function (e) {
      if (touch.matches && !li.classList.contains('is-open')) { e.preventDefault(); closeAll(li); open(li, true); }
    });
  });
  d.addEventListener('click', function (e) { if (!e.target.closest('.tsx__item--mega')) closeAll(); });

  /* 3. drawer */
  var drawer = d.getElementById('tsx-drawer');
  var burger = hd.querySelector('[data-tsx-open]');
  var src = d.getElementById('tsx-mm-src');
  function fill() {
    if (!drawer || drawer.dataset.filled || !src) return;
    drawer.dataset.filled = '1';
    drawer.querySelectorAll('[data-tsx-lazy]').forEach(function (box) {
      var el = src.content.querySelector('[data-k="' + box.dataset.tsxLazy + '"]');
      if (el) while (el.firstChild) box.appendChild(el.firstChild);
    });
  }
  function drawerOpen(on) {
    if (!drawer) return;
    if (on) fill();
    drawer.hidden = !on;
    d.documentElement.style.overflow = on ? 'hidden' : '';
    if (burger) burger.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) { var c = drawer.querySelector('[data-tsx-close]'); if (c) c.focus(); }
    else if (burger) burger.focus();
  }
  if (burger) burger.addEventListener('click', function () { drawerOpen(true); });
  if (drawer) {
    drawer.addEventListener('click', function (e) { if (e.target === drawer || e.target.closest('[data-tsx-close]')) drawerOpen(false); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = drawer.querySelectorAll('a[href],button,summary');
      f = Array.prototype.filter.call(f, function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    // let a phone-width drawer close itself if the window grows to desktop
    w.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches && !drawer.hidden) drawerOpen(false); });
  }

  /* 4. search */
  var search = d.getElementById('tsx-search');
  var sBtn = hd.querySelector('[data-tsx-search]');
  var q = search && search.querySelector('[data-tsx-q]');
  var res = search && search.querySelector('[data-tsx-results]');
  var initial = res ? res.innerHTML : '';
  function searchOpen(on) {
    if (!search) return;
    search.hidden = !on;
    if (sBtn) sBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) { closeAll(); hd.classList.remove('is-away'); if (ann) ann.classList.remove('is-away'); q.focus(); }
    if (over) hd.classList.toggle('is-lit', on);
    if (!on && sBtn) sBtn.focus();
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(u) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=300' : ''; }
  var timer, seq = 0;
  function suggest() {
    var v = q.value.trim();
    if (v.length < 2) { res.innerHTML = initial; return; }
    var n = ++seq;
    fetch((w.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search/suggest.json?q=' + encodeURIComponent(v) +
      '&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (n !== seq) return;
        var r = (j && j.resources && j.resources.results) || {};
        var ps = (r.products || []).slice(0, 8), cs = (r.collections || []).slice(0, 6);
        var all = '<a class="tsx__sall" href="' + esc(search.querySelector('form').action) + '?q=' + encodeURIComponent(v) + '&type=product&options%5Bprefix%5D=last">See all results for “' + esc(v) + '”</a>';
        if (!ps.length && !cs.length) { res.innerHTML = '<p class="tsx__sh">No matches yet</p>' + initial; return; }
        var h = '';
        if (cs.length) h += '<p class="tsx__sh">Collections</p><ul class="tsx__chips" role="list">' + cs.map(function (c) { return '<li><a href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>'; }).join('') + '</ul>';
        if (ps.length) h += '<p class="tsx__sh" style="margin-top:20px">Pieces</p><div class="tsx__sgrid">' + ps.map(function (p) {
          return '<a class="tsx__sp" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(img(p.image)) + '" alt="" loading="lazy" width="300" height="300">' : '') +
            '<span>' + esc(p.title) + '</span>' + (p.price ? '<b>' + esc(money(p.price)) + '</b>' : '') + '</a>';
        }).join('') + '</div>';
        res.innerHTML = h + all;
      }).catch(function () {});
  }
  function money(p) {
    var n = Number(p);
    if (isNaN(n)) return p;
    var cur = (w.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, maximumFractionDigits: n % 1 ? 2 : 0 }).format(n); } catch (e) { return '$' + n; }
  }
  if (search) {
    sBtn && sBtn.addEventListener('click', function () { searchOpen(search.hidden); });
    search.querySelector('[data-tsx-search-close]').addEventListener('click', function () { searchOpen(false); });
    q.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(suggest, 180); });
    d.addEventListener('click', function (e) { if (!search.hidden && !e.target.closest('#tsx-search,[data-tsx-search]')) searchOpen(false); });
  }

  /* Esc closes whatever is open */
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) return drawerOpen(false);
    if (search && !search.hidden) return searchOpen(false);
    var li = hd.querySelector('.tsx__item.is-open,.tsx__item--mega:hover');
    if (li) { open(li, false); hd.setAttribute('data-noh', ''); var a = li.querySelector('.tsx__top'); if (a) a.focus(); setTimeout(function () { open(li, false); }, 0); }
  });

  /* 5. bag count */
  var bubble = hd.querySelector('.tsx__count');
  if (bubble && w.MutationObserver) {
    var sync = function () {
      var n = parseInt(bubble.textContent, 10) || 0;
      if (n > 0) bubble.removeAttribute('data-empty'); else bubble.setAttribute('data-empty', '');
      var a = d.getElementById('cart-icon-bubble');
      if (a) a.setAttribute('aria-label', 'Bag, ' + n + (n === 1 ? ' item' : ' items'));
    };
    new MutationObserver(sync).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  onScroll();
})();
